// import { Button, Col, DatePicker, Form, InputNumber, Row, Select, Typography } from "antd";

// import dayjs from "dayjs";
// import React, { Fragment, useEffect, useState } from "react";

// import { toast } from "react-toastify";

// import { useDispatch, useSelector } from "react-redux";
// import { addLeaveApplication } from "../../redux/rtk/features/leave/leaveSlice";
// import { loadAllLeaveType } from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
// import {
// 	loadAllShift
// } from "../../redux/rtk/features/shift/shiftSlice";
// import getUserFromToken from "../../utils/getUserFromToken";
// import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

// const AddLeave = ({ drawer }) => {
// 	const [loader, setLoader] = useState(false);
// 	const shift = useSelector((state) => state.shift.list);
// 	const { list, loading } = useSelector((state) => state.leavePolicy);
// 	const [endDate, setEndDate] = useState(null);
// 	const [totalDays, setTotalDays] = useState(1);

// 	//get id from JWT token in localstorage and decode it

// 	const id = getUserFromToken();

// 	const dispatch = useDispatch();

// 	useEffect(() => {
// 		dispatch(loadAllShift());
// 		dispatch(loadAllLeaveType());
// 	}, []);

// 	// const calculateEndDate = (startDate, days) => {
// 	//     if (startDate && days) {
// 	//         const newEndDate = dayjs(startDate).add(days, 'day').format('YYYY-MM-DD');
// 	//         setEndDate(newEndDate);
// 	//         form.setFieldsValue({ leaveTo: dayjs(newEndDate) });
// 	//     }
// 	// };
// 	const calculateEndDate = (startDate, days) => {
// 		if (startDate && days) {
// 			let newEndDate;
// 			if (days === 0.5) {
// 				newEndDate = dayjs(startDate).format('YYYY-MM-DD'); // Keep the same date for 0.5 days
// 			} else {
// 				newEndDate = dayjs(startDate).add(days - 1, 'day').format('YYYY-MM-DD');
// 			}
// 			setEndDate(newEndDate);
// 			form.setFieldsValue({ leaveTo: dayjs(newEndDate) });
// 		}
// 	};


// 	const handleTotalDaysChange = (value) => {
// 		setTotalDays(value);
// 		const startDate = form.getFieldValue('leaveFrom');
// 		calculateEndDate(startDate, value);
// 	};

// 	const handleStartDateChange = (date) => {
// 		calculateEndDate(date, totalDays);
// 	};


// 	const { Title } = Typography;
// 	const [form] = Form.useForm();

// 	const onFinish = async (values) => {
// 		const leaveData = {
// 			...values,
// 			userId: id,
// 			leaveFrom: dayjs(values.leaveFrom).format(),
// 			leaveTo: dayjs(values.leaveTo).format(),
// 			totalleaveDays: values.totalleaveDays
// 		};

// 		setLoader(true);
// 		const resp = await dispatch(addLeaveApplication(leaveData));

// 		if (resp.payload.message === "success") {
// 			setLoader(false);
// 			form.resetFields();
// 			setEndDate(null);
// 			setTotalDays(1);
// 			dispatch(loadAllShift());
// 		} else {
// 			setLoader(false);
// 		}
// 	};

// 	const onFinishFailed = (errorInfo) => {
// 		toast.warning("Failed at adding shift");
// 		setLoader(false);
// 	};
// 	return (
// 		<Fragment bordered={false}>
// 			<UserPrivateComponent permission={"create-leaveApplication"}>
// 				<Row className='mr-top' justify={drawer ? "center" : "center"}>
// 					<Col
// 						// xs={24}
// 						// sm={24}
// 						// md={24}
// 						// lg={drawer ? 220 : 160}
// 						// xl={drawer ? 220 : 120}
// 						className=''>
// 						{/* <Title level={4} className='m-2 mt-5 mb-5 text-center'>
// 							Application for Leave
// 						</Title> */}
// 						<Form
// 							form={form}
// 							style={{ marginBottom: "40px" }}
// 							eventKey='shift-form'
// 							name='basic'
// 							labelCol={{
// 								span: 8,
// 							}}
// 							wrapperCol={{
// 								span: 14,
// 							}}
// 							onFinish={onFinish}
// 							onFinishFailed={onFinishFailed}
// 							autoComplete='off'>
// 							<div>
// 								{/* <Form.Item
// 									style={{ marginBottom: "10px" }}
// 									label='Leave Type'
// 									name='leaveTypeId'
// 									rules={[
// 										{
// 											required: true,
// 											message: "Please select a leave type!",
// 										},
// 									]}
// 								>
// 									<Select
// 										mode='single'
// 										placeholder='Select leave type'
// 										optionFilterProp='children'
// 										loading={loading}
// 									>
// 										{list.map((leave) => (
// 											<Select.Option key={leave.id} value={leave.leaveType}>
// 												{leave.leaveType}
// 											</Select.Option>
// 										))}
// 									</Select>
// 								</Form.Item> */}

// 								<Form.Item
// 									style={{ marginBottom: "10px" }}
// 									label="Leave Type"
// 									name="leaveTypeId"
// 									rules={[
// 										{
// 											required: true,
// 											message: "Please select a leave type!",
// 										},
// 									]}
// 								>
// 									<Select
// 										mode="single"
// 										placeholder="Select leave type"
// 										optionFilterProp="children"
// 										loading={loading}
// 									>
// 										{list.map((leave) => (
// 											<Select.Option key={leave.id} value={leave.id}>
// 												{leave.leaveType}
// 											</Select.Option>
// 										))}
// 									</Select>
// 								</Form.Item>



// 								<Form.Item
// 									style={{ marginBottom: "10px" }}
// 									label='Start Date'
// 									name='leaveFrom'
// 									rules={[
// 										{
// 											required: true,
// 											message: "Please input your shift!",
// 										},
// 									]}>
// 									<DatePicker />
// 								</Form.Item>

// 								<Form.Item
// 									style={{ marginBottom: "10px" }}
// 									label='Total Days'
// 									name='totalleaveDays'
// 									rules={[{ required: true, message: "Please enter the total days!" }]}>
// 									<InputNumber min={0.5} step={0.5} onChange={handleTotalDaysChange} />
// 								</Form.Item>

// 								<Form.Item
// 									style={{ marginBottom: "20px" }}
// 									label='End Date'
// 									name='leaveTo'
// 								>
// 									<DatePicker value={endDate ? dayjs(endDate) : null} disabled />
// 								</Form.Item>

// 								<Form.Item
// 									style={{ marginBottom: "10px" }}
// 									wrapperCol={{
// 										offset: 6,
// 										span: 12,
// 									}}>
// 									<Button
// 										onClick={() => setLoader(true)}
// 										type='primary'
// 										size='large'
// 										htmlType='submit'
// 										block
// 										loading={loader}>
// 										Submit Leave
// 									</Button>
// 								</Form.Item>
// 							</div>
// 						</Form>
// 					</Col>
// 				</Row>
// 			</UserPrivateComponent>
// 		</Fragment>
// 	);
// };

// export default AddLeave;

import { Button, Col, DatePicker, Form, InputNumber, Row, Select } from "antd";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addLeaveApplication, getSingleLeaveAllocation } from "../../redux/rtk/features/leave/leaveSlice";
// import { loadAllLeaveType } from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

dayjs.extend(utc);
dayjs.extend(timezone);

const AddLeave = ({ drawer }) => {
  const [loader, setLoader] = useState(false);
  const shift = useSelector((state) => state.shift.list);
  // const { list, loading } = useSelector((state) => state.leavePolicy);
  const [endDate, setEndDate] = useState(null);
  const [totalDays, setTotalDays] = useState(1);
  const id = getUserFromToken();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const userId = getUserFromToken();


  // const list = useSelector((state) => state.leave.leave);
  //   console.log('allocateoiugf>>', list);
  const list = useSelector((state) => state.leave.leave) || [];
  console.log('list>>', list);
  const loading = useSelector((state) => state.loading || []);
  console.log('loading>>', loading);



  useEffect(() => {
    dispatch(loadAllShift());
    dispatch(getSingleLeaveAllocation(userId));
  }, [dispatch, userId]);

  // useEffect(() => {
  //   dispatch(loadAllShift());
  //   // dispatch(loadAllLeaveType());
  // }, [dispatch]);

  const calculateEndDate = (startDate, days) => {
    if (startDate && days) {
      let newEndDate;
      // Math.ceil() will round up any partial days
      // For example: 1.25, 1.5, 1.75 will all round up to 2
      const daysToAdd = Math.ceil(days) - 1;
      
      newEndDate = dayjs(startDate).add(daysToAdd, 'day');
      setEndDate(newEndDate);
      form.setFieldsValue({ leaveTo: newEndDate });
    }
  };

  const handleTotalDaysChange = (value) => {
    setTotalDays(value);
    const startDate = form.getFieldValue('leaveFrom');
    calculateEndDate(startDate, value);
  };

  const handleStartDateChange = (date) => {
    calculateEndDate(date, totalDays);
  };

  const formatDate = (date) => {
    return dayjs(date)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  };

  const onFinish = async (values) => {
    try {
      setLoader(true);
      const leaveData = {
        ...values,
        userId: id,
        leaveFrom: formatDate(values.leaveFrom),
        leaveTo: formatDate(values.leaveTo),
        totalleaveDays: values.totalleaveDays
      };

      const resp = await dispatch(addLeaveApplication(leaveData));

      if (resp.payload.message === "success") {
        // toast.success("Leave application submitted successfully");
        form.resetFields();
        setEndDate(null);
        setTotalDays(1);
        dispatch(loadAllShift());
      } else {
        // toast.error("Failed to submit leave application");
      }
    } catch (error) {
      toast.error("An error occurred while submitting leave application");
    } finally {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Please fill all required fields");
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-leaveApplication"}>
        <Row className='mr-top' justify={drawer ? "center" : "center"}>
          <Col className=''>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name='leave-form'
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Leave Type"
                name="leaveTypeId"
                rules={[{ required: true, message: "Please select a leave type!" }]}
              >
                <Select
                  mode="single"
                  placeholder="Select leave type"
                  optionFilterProp="children"
                >
                  {list.length > 0 ? (
                    list.map((leave) => (
                      <Select.Option key={leave.leaveType.id} value={leave.leaveType.id}>
                        {leave.leaveType.leaveType}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option disabled>No leave types available</Select.Option>
                  )}
                </Select>
              </Form.Item>


              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Start Date'
                name='leaveFrom'
                rules={[{ required: true, message: "Please select start date!" }]}
              >
                <DatePicker
                  onChange={handleStartDateChange}
                  format="DD-MM-YYYY"
                  showTime={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Total Days'
                name='totalleaveDays'
                rules={[{ required: true, message: "Please enter the total days!" }]}
              >
                <InputNumber
                  min={0.25}
                  step={0.25}
                  onChange={handleTotalDaysChange}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "20px" }}
                label='End Date'
                name='leaveTo'
              >
                <DatePicker
                  value={endDate}
                  disabled
                  format="DD-MM-YYYY"
                  showTime={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ offset: 6, span: 12 }}
              >
                <Button
                  type='primary'
                  size='large'
                  htmlType='submit'
                  block
                  loading={loader}
                  disabled={loader}
                >
                  {loader ? 'Submitting...' : 'Submit Leave'}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
    </Fragment>
  );
};

export default AddLeave;